export default __webpack_public_path__ + "static/tip-piano-glow-0bdeb1461d1e7523a77bbd979d4b206e.png";